/**
 * Dropdown widget loaded inside its own iframe
 */
import invitationWidgetTemplate from '../templates/invitations/invitation.ejs';
import { BaseWidget } from '../core/BaseWidget';
import WidgetTypes from '../core/enums/WidgetTypes';
import DoAnimator from '../core/DoAnimator';
import ChatMode from '../core/hooks/ChatMode';
import addStyleTextInIframe from '../core/hooks/addStyleTextInIframe';
import { AnimationType } from '../core/enums/Enum';
import parseTemplate from '../core/hooks/parseTemplate';
import addStyleText from '../core/hooks/addStyleText';
import TempStorageCache from '../core/hooks/TempStorageCache';
import BehaviorTypes from '../core/hooks/BehaviorTypes';
import AgentImageHandler from '../core/hooks/AgentImageHandler';
import observe from '../core/hooks/observe';
import Cookies from '../core/hooks/Cookies';
import ChatEvents from '../core/hooks/ChatEvents';
import WidgetStates from '../core/hooks/WidgetStates';
import showElement from '../core/hooks/showElement';
import hideElement from '../core/hooks/hideElement';
import removeClass from '../core/hooks/removeClass';
import replaceClass from '../core/hooks/replaceClass';
import addClass from '../core/hooks/addClass';
import logIt from '../../logIt';

export default class DropDownInvitation extends BaseWidget {
    constructor(options) {
        super(Object.assign(options, { widget: WidgetTypes.DropDown, styleName: 'invitation' }));
        Object.assign(this.options, {
            containerId: 'apexchat_invitation_container_wrapper'
        });
        this.addBehavior(BehaviorTypes.NOTIFICATIONS);
        this.addBehavior(BehaviorTypes.INVITATION_CLICKABLES);
        addStyleText(this.options.invitationWidgetStyle);
        // dont need to add Invitation other than IFRAME

        this.state.changeState({ toState: WidgetStates.Requested });
        this.ready();
    }

    ready() {
        super.ready();
        this.state.changeState({ toState: WidgetStates.Ready });
        const me = this;
        const minimizeIt = function () {
            me.hide();
            me.minimize(false, WidgetStates.Hidden);
        };
        const hideIt = function () {
            // on click of invitation we need to hide the Masking.
            me.postMessage({ event: 'dropdown-hidemask', data: {} });
            if (me.options.chatMode == ChatMode.DOM) {
                me.hide();
            } else {
                me.show(true);
            }
        };
        const showIt = function (args) {
            // before showing invitation we need to clear the animations.
            new DoAnimator().clearAnimations();
            me.show(args ? args.onDomMinimized : false);
        };
        const chatStartedFromExitPopup = function () {
            me.hide();
        };
        const chatStartedFromVideoGreet = function () {
            me.hide();
        };
        // in case of EP close(ONLY), we need it to be called so we will resetNotifications.
        const chatClosedFromExitPopup = function (args) {
            showIt(args);
            if (me.canWidgetShowNotifications()) {
                me.resetNotificationCount();
            }
        };
        const onAnyInvitationClick = function () {
            me.state.setStateValue({ state: WidgetStates.ShownMinimized, value: false });
            me.maximize(false);
        };
        this.subscribe(WidgetTypes.Test + WidgetStates.ShownMaximized, () => {
            logIt("Yes,I'm here");
        });
        this.subscribe('videogreet-gif-file-loaded', (data) => {
            const wrap = (el, wrappingElement) => {
                wrappingElement = document.createElement('div');
                el.replaceWith(wrappingElement);
                wrappingElement.appendChild(el);
            };
            if (data.imageUrl) {
                const indicator = me.DOM.getElementById('apexchat_rd_agent_img');
                if (indicator) {
                    wrap(
                        indicator,
                        `<div class='apexchat_rd_agent_icon_gif' style='background-image:url(${AgentImageHandler(data.imageUrl)})'></div>`
                    );
                    indicator.setAttribute('src', AgentImageHandler(data.imageUrl));
                }
            }
        });
        this.subscribe('videogreet-init', () => {
            const lastVGState = me.state.getStateValue(WidgetTypes.VideoGreetInvitation); // get video greet state
            if (lastVGState != WidgetStates.Hidden && !me.isPageRefreshed()) {
                // check video greet maximize
                me.isVideoGreetMax = true;
            }
        });
        this.subscribe(
            WidgetTypes.VideoGreetInvitation + WidgetStates.ShownMaximized,
            chatStartedFromVideoGreet
        );

        this.subscribe(WidgetTypes.DOM + WidgetStates.ShownMinimized, showIt);
        this.subscribe(WidgetTypes.DOM + WidgetStates.Closed, showIt);
        this.subscribe(
            WidgetTypes.ExitPopup + WidgetStates.Closed,
            chatClosedFromExitPopup
        );
        this.subscribe(WidgetTypes.Bar + WidgetStates.Clicked, hideIt);
        this.subscribe(WidgetTypes.Tab + WidgetStates.Clicked, hideIt);
        this.subscribe(WidgetTypes.PreChat + WidgetStates.Clicked, hideIt);
        this.subscribe(WidgetTypes.DropDown + WidgetStates.Clicked, hideIt);
        this.subscribe(WidgetTypes.SMS + WidgetStates.Clicked, hideIt);
        this.subscribe(
            WidgetTypes.ExitPopup + WidgetStates.ShownMaximized,
            chatStartedFromExitPopup
        );
        this.subscribe(WidgetTypes.ExitPopup + WidgetStates.Hidden, hideIt);
        this.subscribe(WidgetTypes.VisitorForm + WidgetStates.ShownMaximized, hideIt);
        this.subscribe(
            WidgetTypes.DynamicVisitorForm + WidgetStates.ShownMaximized,
            hideIt
        );
        this.subscribe(
            WidgetTypes.DynamicVisitorForm + WidgetStates.DynamicVisitorFormSubmitted,
            showIt
        );
        this.subscribe(
            WidgetTypes.DynamicVisitorForm + WidgetStates.DynamicVisitorFormCancelled,
            showIt
        );
        this.subscribe(WidgetTypes.VideoGreetInvitation + WidgetStates.Closed, minimizeIt);
        me.subscribe(
            WidgetTypes.ChatRoom + ChatEvents.OnParticipantsChanged,
            (participants) => {
                me.onParticipantsChanged(participants);
            }
        );
        me.subscribe(WidgetTypes.ChatRoom + ChatEvents.OnMessageArrived, (args) => {
            if (me.canWidgetShowNotifications()) {
                me.increaseNotificationCounter(args);
            }
        });
        if (me.isPageRefreshed()) {
            // in case of page reload, show previous msg counter
            this.subscribe(ChatEvents.OnHistoryLoadedCompletely, () => {
                if (me.canWidgetShowNotifications()) {
                    me.showNotificationCountOnReload();
                }
            });
        }

        this.create();
    }

    onParticipantsChanged(participants) {
        const me = this;
        ApexChat.localStorageAPI.Store('livechat_chat_participants', JSON.stringify(participants));
        const participant = participants[participants.length - 1];
        const indicator = me.DOM.getElementById('apexchat_rd_agent_img');
        const invitationTitleElement = me.DOM.getElementsByClassName('livechat_header');
        if (me.options.agentName && participant) {
            me.options.agentName = participant.displayName;
            if (participant.handlerImageUrl) {
                const imageUrl = participant.handlerImageUrl;
                indicator.setAttribute('src', AgentImageHandler(imageUrl));
                if (invitationTitleElement && invitationTitleElement.length > 0) {
                    invitationTitleElement[0].innerText = `Chat with ${participant.displayName}`;
                }
            }
        }
    }

    create() {
        super.create();
        const me = this;
        // this.$('#test').apexChatDropSelect();
        this.options.handlerImageUrl = AgentImageHandler(this.options.handlerImageUrl);
        this.options.invitationText = parseTemplate(
            this.options.invitationTextTemplate,
            this.options
        );
        this.options.invitationActionText = parseTemplate(
            this.options.invitationActionTextTemplate,
            this.options
        );
        this.options.invitationHeader = parseTemplate(
            this.options.invitationHeaderTemplate,
            this.options
        );
        this.options.invitationMinimizedText = parseTemplate(
            this.options.invitationMinimizedTextTemplate,
            this.options
        );
        this.options.invitationMinimizedActionText = parseTemplate(
            this.options.invitationMinimizedActionTextTemplate,
            this.options
        );
        this.options.invitationInProgressText = parseTemplate(
            this.options.invitationInProgressTextTemplate,
            this.options
        );
        this.options.invitationInProgressActionText = parseTemplate(
            this.options.invitationInProgressActionTextTemplate,
            this.options
        );
        this.options.invitationCloseText = parseTemplate(
            this.options.invitationCloseTextTemplate,
            this.options
        );
        this.options.invitationTabText = parseTemplate(
            this.options.invitationTabTextTemplate,
            this.options
        );
        this.options.invitationMinimizedTabText = parseTemplate(
            this.options.invitationMinimizedTabTextTemplate,
            this.options
        );
        this.options.invitationInProgressTabText = parseTemplate(
            this.options.invitationInProgressTabTextTemplate,
            this.options
        );
        this.options.invitationWidgetTemplate =
            invitationWidgetTemplate(this.options);


        this.subscribe(WidgetTypes.DropDown + WidgetStates.Refreshed, (data) => {
            me.minimize(false, WidgetStates.ShownMaximized);
        });
        this.subscribe('rounded-dynamic-maximized-size', (args) => {
            const invitationPosition = me.options.position == 1 ? 'left' : 'right'; // RD works on Left/Right only for now
            const wrapper = me.DOM.querySelector('#apexchat_invitation_container_wrapper');
            wrapper.classList.add(
                `apexchat_rd_maximized_invitation_iframe_distance_${invitationPosition}`
            );
            // 5406 - Added animations for Flip and Glow effects
            ApexChat.glowOptions = {
                element: me.DOM.querySelector('#apexchat_rd_invitation_bg'),
                wrapperDiv: wrapper,
                parentDiv: document.getElementById(me.options.parentDivId),
                iframeDiv: document.getElementById(me.options.iframeId)
            };
            switch (me.options.rDInviteAnimationType) {
                case AnimationType.Flip:
                    new DoAnimator().flip(
                        me.$('#apexchat_invitation_container_wrapper', me.DOM),
                        4000
                    );
                    break;
                case AnimationType.Glow:
                    new DoAnimator().glow(ApexChat.glowOptions, 2000);
                    break;
                case AnimationType.None: // do nothing..
                    break;
                default:
                    break;
            }
        });
        this.subscribe('rounded-dynamic-preserve-scroll-before-maximizing', (args) => {
            // JIRA_5314/5315 - saving the Scroll position on maximizing RD DOM
            if (me.options.isMobile) {
                TempStorageCache.add(
                    'preserveBodyScrollPosition',
                    document.body.scrollTop == null ? 0 : document.body.scrollTop
                );
            }
        });
        this.subscribe('rounded-dynamic-minimized-size', (args) => {
            new DoAnimator().clearAnimations();
            switch (me.options.rDInviteAnimationType) {
                case AnimationType.Flip:
                    // new DoAnimator().flipCoin(me.$('#apexchat_rd_invitation_bg', me.DOM), 4000);
                    new DoAnimator().flipCoin(
                        me.DOM.querySelector('#apexchat_rd_invitation_bg'),
                        4000
                    );
                    break;
                case AnimationType.Glow:
                    new DoAnimator().glow(ApexChat.glowOptions, 2000);
                    break;
                case AnimationType.None: // do nothing..
                    break;
                default:
                    break;
            }
            const invitation = me.DOM.getElementById('apexchat_rd_invitation_bg');
            const invitationBubble = me.DOM.getElementById('apexchat_rd_invitation_bubble');
            const invitationPosition = me.options.position == 1 ? 'left' : 'right'; // RD works on Left/Right only for now
            if (Cookies.get('livechat_exitpopup_dom_closed')) {
                replaceClass(
                    invitation,
                    'apexchat_rd_animated apexchat_rd_bounceInUp',
                    `apexchat_rd_zoomIn_${invitationPosition}`
                );
            }
            addClass(invitation, `apexchat_rd_zoomIn_${invitationPosition}`);
            addClass(invitation, 'apexchat_rd_invitation_minimize');
            const agentImgMinimize = me.DOM.querySelector('.apexchat_rd_agent_img');
            const onlineIndicatorMinimize = me.DOM.querySelector('.apexchat_rd_green');
            addClass(
                invitationBubble,
                `apexchat_rd_invitation_bubble_position_${invitationPosition}`
            );
            addClass(
                onlineIndicatorMinimize,
                `apexchat_rd_green_minimize_${invitationPosition}`
            );
            addClass(agentImgMinimize, 'apexchat_rd_agent_img_minimize');
            me.DOM.getElementById('apexchat_rd_invitation_close').style.display = 'none';
            me.DOM.getElementById('apexchat_rd_invitation_title').style.display = 'none';
            // adjust msg counter if it was showing in max form previously
            const { containerId } = me.options;
            me.DOM.getElementById(containerId).style.left = '';
            setTimeout(() => {
                // me.$('#apexchat_rd_invitation_bg', me.DOM).addClass(
                //     `apexchat_rd_invitation_bg_right_position_fixed_${invitationPosition}`
                // );
                me.DOM.querySelector('#apexchat_rd_invitation_bg').classList.add(
                    `apexchat_rd_invitation_bg_right_position_fixed_${invitationPosition}`
                );
                // to fix iOS issue: CHAT-5415
                // me.$('#apexchat_invitation_container_wrapper', me.DOM).addClass(
                //     `apexchat_rd_minimized_${invitationPosition}`
                // );
                me.DOM.querySelector('apexchat_invitation_container_wrapper')?.classList.add(
                    `apexchat_rd_minimized_${invitationPosition}`
                );
                // to fix iOS issue: CHAT-5415
            }, 50);
            // notify all interested
            me.state.changeState({ toState: WidgetStates.ShownMinimized });
        });

        this.createRDInvitation();
        // me.resetNotificationCount();
        if (me.hasCustomClickHandlersDefined()) {
            me.setStartChatHandler(() => {
                me.resetNotificationCount();
            });

            me.setCloseInvitationHandler(() => {
                me.postMessage({ event: 'rounded-dynamic-minimized-size' });
            });

            addClass(
                document.getElementById(me.options.parentDivId),
                'apexchat_rd_animated'
            );
            addClass(
                document.getElementById(me.options.parentDivId),
                'apexchat_rd_bounceInUp'
            );
            removeClass(
                me.DOM.getElementById('apexchat_rd_invitation_bg'),
                'apexchat_rd_bounceInUp'
            );
        }

        const pageIsRefreshed = this.isPageRefreshed();
        const render = function () {
            // inform outside parent/wrapper div to resize and animate as per min/max state
            let { containerId } = me.options;
            if (pageIsRefreshed) {
                const lastState = me.getCurrentState();
                if (me.options.rememberShownState) {
                    if (
                        (lastState && lastState == WidgetStates.ShownMinimized) ||
                        me.options.alwaysShowMinimizedInviteInSecondaryLocation
                    ) {
                        containerId = me.options.minimizedContainerId;
                    }
                }
            }
            me.postMessage({
                event: 'dropdown-size',
                data: { containerId, onCreateSizing: true }
            });
            me.show();
        };
        const timeout = me.isPageRefreshed()
            ? this.options.subsequentLoadTimeout
            : this.options.initialLoadTimeout;
        logIt(`DD:: rending in ${timeout}`);
        window.setTimeout(render.bind2(this), timeout);
    }

    setCloseInvitationHandler(cb) {
        const me = this;
        const close = function (cb) {
            const invitation = me.DOM.getElementById('apexchat_rd_invitation_bg');
            addClass(invitation, 'apexchat_rd_invitation_bg_width');
            me.DOM.getElementById('apexchat_rd_invitation_close').style.display = 'none';
            me.DOM.getElementById('apexchat_rd_invitation_title').style.display = 'none';
            if (cb && typeof cb === 'function') {
                cb();
            }
        };
        observe(me.DOM.getElementById('apexchat_rd_invitation_close'), 'click', () => {
            close(cb);
        });
        me.handleADA(me.DOM.getElementById('apexchat_rd_invitation_close'), () => {
            close(cb);
        });
    }



    createRDInvitation() {
        this.createMaximized();
        this.createMinimized();
        addStyleTextInIframe(
            this.options.rdThemeChat.invitationCss,
            undefined,
            undefined,
            this.DOM
        );
        if (this.options.invitationWidgetStyleCustom) {
            addStyleTextInIframe(
                this.options.invitationWidgetStyleCustom,
                undefined,
                undefined,
                this.DOM
            );
        }
        // apply any additional styles to deal with IE in quirks mode
        // if (Browser.isIE() && Browser.isQuirksMode() && this.options.invitationWidgetStyleQuirks) {
        //     addStyleTextInIframe(
        //         this.options.invitationWidgetStyleQuirks,
        //         undefined,
        //         undefined,
        //         this.DOM
        //     );
        // }
        // if (Browser.isIE6() && this.options.invitationWidgetStyleIE6) {
        //     addStyleTextInIframe(
        //         this.options.invitationWidgetStyleIE6,
        //         undefined,
        //         undefined,
        //         this.DOM
        //     );
        // }
    }

    createMaximized() {
        // create the invitation
        const me = this;
        const container = this.addElement(
            this.options.containerId,
            this.options.invitationWidgetTemplate
        );

        if (this.options.isChevronStyleDOM) {
            // Todo:
            this.DOM.getElementsByClassName('livechat')[0].style.top = '36px';
        }
        // JIRA_3228 - ChevronBoxStyle DOM - START
        if (me.options.invitationWidgetStyleCustom.indexOf('IsChevronBOXStyleDOM') !== -1) {
            ApexChat.chevronStyleArrowFontSize = 'apexchat-icon-white-13';
            ApexChat.chevronStyleArrowUp = 'apexchat-icon-up-open';
            ApexChat.chevronStyleArrowDown = 'apexchat-icon-down-open';
            var chevronArrowDirection = this.DOM.getElementById(me.options.mobileDOM_Chevron);
            var chevronArrowDirectionMinimized = this.DOM.getElementById(
                me.options.mobileDOM_ChevronInMinimizedContainer
            );
            addClass(chevronArrowDirection, ApexChat.chevronStyleArrowFontSize);
            addClass(chevronArrowDirectionMinimized, ApexChat.chevronStyleArrowFontSize);
            addClass(chevronArrowDirectionMinimized, ApexChat.chevronStyleArrowUp);
        } else {
            ApexChat.chevronStyleArrowFontSize = 'apexchat-icon-white-25';
            ApexChat.chevronStyleArrowUp = 'apexchat-icon-angle-double-up';
            ApexChat.chevronStyleArrowDown = 'apexchat-icon-angle-double-down';
            var chevronArrowDirection = this.DOM.getElementById(me.options.mobileDOM_Chevron);
            var chevronArrowDirectionMinimized = this.DOM.getElementById(
                me.options.mobileDOM_ChevronInMinimizedContainer
            );
            addClass(chevronArrowDirection, ApexChat.chevronStyleArrowFontSize);
            addClass(chevronArrowDirectionMinimized, ApexChat.chevronStyleArrowFontSize);
            addClass(chevronArrowDirectionMinimized, ApexChat.chevronStyleArrowUp);
        }
        // JIRA_3228 - ChevronBoxStyle DOM - End
        replaceClass(
            this.DOM.getElementById(me.options.mobileDOM_Chevron),
            ApexChat.chevronStyleArrowUp,
            ApexChat.chevronStyleArrowDown
        );
        observe(
            this.DOM.getElementById(me.options.mobileDOM_MinimizeInvitation),
            'click',
            function () {
                if (!ApexChat.toggleChevrons) {
                    replaceClass(
                        this.DOM.getElementById(me.options.mobileDOM_Chevron),
                        ApexChat.chevronStyleArrowDown,
                        ApexChat.chevronStyleArrowUp
                    );
                    replaceClass(
                        this.DOM.getElementById(me.options.containerId),
                        'apexchat_chevronstyle_dom_normal_invitation',
                        'apexchat_chevronstyle_dom_minimize_invitation'
                    );
                    replaceClass(
                        this.DOM.getElementById(me.options.mobileDOM_AgentImage),
                        'apexchat_chevronstyle_elements_show',
                        'apexchat_chevronstyle_elements_hide'
                    );
                    if (
                        me.options.invitationWidgetStyleCustom.indexOf('IsChevronBOXStyleDOM') !==
                        -1
                    ) {
                        replaceClass(
                            this.DOM.getElementById(me.options.mobileDOM_MinimizeInvitation),
                            'apexchat_chevronstyle_box_normal_indicator',
                            'apexchat_chevronstyle_box_minimized_indicator'
                        );
                    }
                    this.DOM.getElementsByClassName('livechat')[0].style.top = '0px';
                    ApexChat.toggleChevrons = true;
                    me.postMessage({
                        event: 'dropdown-chevronStyle-minimize',
                        data: { IsDropDownMinimized: ApexChat.toggleChevrons }
                    });
                } else {
                    // Right now when
                    replaceClass(
                        this.DOM.getElementById(me.options.mobileDOM_Chevron),
                        ApexChat.chevronStyleArrowUp,
                        ApexChat.chevronStyleArrowDown
                    );
                    replaceClass(
                        this.DOM.getElementById(me.options.containerId),
                        'apexchat_chevronstyle_dom_minimize_invitation',
                        'apexchat_chevronstyle_dom_normal_invitation'
                    );
                    replaceClass(
                        this.DOM.getElementById(me.options.mobileDOM_AgentImage),
                        'apexchat_chevronstyle_elements_hide',
                        'apexchat_chevronstyle_elements_show'
                    );
                    if (
                        me.options.invitationWidgetStyleCustom.indexOf('IsChevronBOXStyleDOM') !==
                        -1
                    ) {
                        replaceClass(
                            this.DOM.getElementById(me.options.mobileDOM_MinimizeInvitation),
                            'apexchat_chevronstyle_box_minimized_indicator',
                            'apexchat_chevronstyle_box_normal_indicator'
                        );
                    }
                    replaceClass(
                        this.DOM.getElementById(me.options.containerId),
                        'apexchat_chevronstyle_elements_show',
                        'apexchat_chevronstyle_elements_hide'
                    );
                    ApexChat.toggleChevrons = false;
                    me.postMessage({
                        event: 'dropdown-chevronStyle-minimize',
                        data: { IsDropDownMinimized: ApexChat.toggleChevrons }
                    });
                }
            }
        );
        // hook into the click event
        me.setClickCallToAction(
            this.options.callToActionId || this.options.containerId,
            'Standard'
        );
        observe(
            this.DOM.getElementById(this.options.closeButtonId),
            'click',
            this.close.bind2(this)
        );
        const altClose = this.DOM.getElementById(this.options.altCloseButtonId);
        if (altClose) {
            observe(altClose, 'click', this.close.bind2(this));
            me.handleADA(altClose, me.close.bind2(this));
        }
        me.handleADA(this.DOM.getElementById(this.options.closeButtonId), me.close.bind2(this));
    }

    startChatFromDropDown() {
        const me = this;
        if (me.options.chatMode == ChatMode.Windowed) {
            me.bindWindowedHandler(WidgetTypes.DropDown);
        }
    }

    createMinimized() {
        const container = this.addElement(
            this.options.minimizedContainerId,
            this.options.invitationWidgetTemplateMinimized
        );
        const me = this;
        const minimizedCallToAction = this.DOM.getElementById(this.options.minimizedCallToActionId);
        if (minimizedCallToAction) {
            // required to handle windowed chat
            me.$(`#${me.options.minimizedCallToActionId}`, me.DOM).click(() => {
                me.startChatFromDropDown();
            });
            me.setClickCallToAction(this.options.minimizedCallToActionId, 'DropDown');
        } else {
            // otherwise, there's a click->expand option
            observe(
                this.DOM.getElementById(this.options.minimizedContainerId),
                'click',
                this.maximize.bind2(WidgetStates.ShownMaximized)
            );
            me.handleADA(
                me.DOM.querySelector(this.options.minimizedContainerId),
                this.maximize.bind2(WidgetStates.ShownMaximized)
            );
        }
        this.monitorIE(this.DOM.getElementById(this.options.minimizedContainerId));
    }

    close(e) {
        new DoAnimator().clearAnimations();
        e = e || window.event;
        e.cancelBubble = true;
        if (e.stopPropagation) {
            e.stopPropagation();
        }
        if (this.options.hideOnClose) {
            this.hide();
        } else {
            this.minimize(false, WidgetStates.ShownMaximized);
        }
        // on close we need to hide the Masking if its enabled.
        if (this.options.invitationMask) {
            this.postMessage({ event: 'dropdown-hidemask', data: {} });
        }
    }

    show(onDomMinimized) {
        const lastState = this.getCurrentState();
        super.show();
        const me = this;
        const isChatActive = me.isChatActive();
        const lastDOMState = this.state.getStateValue(WidgetTypes.DOM);
        const lastEPState = this.state.getStateValue(WidgetTypes.ExitPopup);
        const lastVGState = this.state.getStateValue(WidgetTypes.VideoGreetInvitation);
        const hideRuleIfEPOnScreen =
            lastEPState === WidgetStates.ShownMaximized ||
            lastEPState === WidgetStates.ShownMinimized;
        const hideRuleIfVideoGreetOnScreen =
            lastVGState === WidgetStates.ShownMaximized ||
            lastVGState === WidgetStates.ShownMinimized;
        const hideRuleIfClosed =
            lastState === WidgetStates.Hidden &&
            /* && this.options.hideOnClose */ this.options.maintainHiddenState;
        const hideRuleIfDOMOpen =
            (lastState === WidgetStates.Hidden ||
                lastState === WidgetStates.ShownMinimized) &&
            lastDOMState === WidgetStates.ShownMaximized;
        // Adjust invitation position when last state is minimized or closed
        const dropDownMaximizeScenario =
            lastDOMState == WidgetStates.ShownMinimized ||
            lastDOMState == WidgetStates.Closed ||
            !isChatActive;
        const dropDownMinimizeScenario =
            (lastState === WidgetStates.ShownMinimized ||
                lastState === WidgetStates.Hidden) &&
            isChatActive; // dropdown minimize only work when chat is active other wise it is maximize(shows invitiaton)

        if (me.hasBeenShown() && !onDomMinimized) {
            // checking page refresh and visitor DOM minimize click action
            logIt('DD::show::reload');
            if (
                hideRuleIfClosed ||
                hideRuleIfDOMOpen ||
                hideRuleIfEPOnScreen ||
                hideRuleIfVideoGreetOnScreen
            ) {
                this.hide();
            } else if (this.options.rememberShownState) {
                // No DOM/No EP on screen, decide display based on portal level flags
                if (this.options.alwaysShowMinimizedInviteInSecondaryLocation) {
                    if (this.options.maintainMinimizedState) {
                        this.minimize(false);
                    } else if (this.options.alwaysShowMinimizedInviteInSecondaryLocation) {
                        this.minimize(false);
                    } else {
                        this.maximize(false);
                    }
                } else if (lastState === WidgetStates.ShownMaximized) {
                    this.maximize(false);
                } else if (lastState === WidgetStates.ShownMinimized) {
                    // Maintain last minimized state when Remember Shown State flag is set - CHAT-4871
                    this.minimize(false);
                } else {
                    // Adjust invitation position when last state is minimized
                    if (lastDOMState == WidgetStates.ShownMinimized) {
                        this.minimize(false);
                    }
                    // Adjust invitation position when last state is closed
                    // Even chat is active and someone close the EP, we need to show the invitation
                    else if (
                        lastDOMState == WidgetStates.Closed ||
                        !isChatActive ||
                        lastEPState === WidgetStates.Closed
                    ) {
                        this.maximize(false);
                    }
                }
            } else if (
                dropDownMaximizeScenario &&
                lastState !== WidgetStates.ShownMinimized
            ) {
                this.maximize(false);
            } else if (
                dropDownMinimizeScenario ||
                lastState === WidgetStates.ShownMinimized
            ) {
                this.minimize(false);
            }
        } else {
            logIt('DD::show::');
            if (me.hasBeenShown()) {
                if (lastState == WidgetStates.ShownMaximized) {
                    if (me.options.chatMode == ChatMode.Windowed) {
                        this.minimize(true);
                    } else {
                        this.maximize(true);
                    }
                } else if (lastState == WidgetStates.ShownMinimized) {
                    this.minimize(true);
                } else if (lastState == WidgetStates.Hidden) {
                    const noChatOpenHideIt =
                        hideRuleIfEPOnScreen || hideRuleIfDOMOpen || hideRuleIfVideoGreetOnScreen;
                    if (!noChatOpenHideIt) {
                        this.minimize(true);
                    } else {
                        this.hide();
                    }
                } else {
                    this.minimize(true);
                }
            } else {
                this.maximize(true);
            }
            me.setShown();
        }
        // bind events
        this.state.addStateHandler(WidgetStates.Closed, () => {
            me.close();
        });
        me.subscribe(WidgetTypes.ChatRoom + ChatEvents.OnTypingArrived, (args) => {
            if (me.canWidgetShowNotifications()) {
                const { showRoundedDynamicIcon } = me.options.rdThemeChat;
                if (args.indicator && !showRoundedDynamicIcon) {
                    me.showTypingInMinimizedState();
                    me.hideMsgCounts();
                } else if (showRoundedDynamicIcon) {
                    if (args.indicator) {
                        me.showTypingWithAnimatedDotsInMinimizedState();
                    } else {
                        me.hideTypingWithAnimatedDotsInMinimizedState();
                    }
                } else {
                    me.hideTypingInMinimizedState();
                    me.showMsgCounts();
                }
            }
        });
        setTimeout(() => {
            // wait until the widget is displayed on page
            // set custom behaviors by Rounded dynamic theme
            if (me.canWidgetShowNotifications()) {
                me.setupNotification();
                if (lastState == WidgetStates.ShownMinimized) {
                    me.hideTypingWithAnimatedDotsInMinimizedState();
                    if (me.options.rdThemeChat.showRoundedDynamicIcon) {
                        me.showTypingWithAnimatedDotsContainer();
                    }
                } else if (lastState == WidgetStates.ShownMaximized) {
                    if (me.options.rdThemeChat.showRoundedDynamicIcon) {
                        me.showTypingWithAnimatedDotsInMinimizedState();
                    } else {
                        me.hideTypingWithAnimatedDotsInMinimizedState();
                        me.showTypingWithAnimatedDotsContainer();
                    }
                } else if (me.options.rdThemeChat.showRoundedDynamicIcon) {
                    me.showTypingWithAnimatedDotsContainer();
                } else {
                    me.hideTypingWithAnimatedDotsInMinimizedState();
                    me.showTypingWithAnimatedDotsContainer();
                }
            }
        }, 500);
    }

    minimize(onCreate) {
        const me = this;
        // for RD, we have to show it but then nned to adjust it in Minimized state
        me.maximize();
        me.postMessage({ event: 'rounded-dynamic-minimized-size' });
        return;
    }

    maximize(onCreate) {
        // ==>WidgetStates.ShownNormal not WidgetStates.ShownMaximized
        const me = this;
        const el = this.DOM.getElementById(this.options.containerId);
        if (el) {
            setTimeout(() => {
                if (!me.isVideoGreetMax) {
                    // check video greet maximize
                    el.style.visibility = 'visible';
                }
                me.isVideoGreetMax = false;
            }, 100);
            el.style.visibility = 'hidden';
            showElement(el);
            hideElement(me.DOM.getElementById(me.options.minimizedContainerId));

            me.postMessage({ event: 'rounded-dynamic-maximized-size' }); // to add custom behavior; TODO: we have to get rid of this conditional approach; it's messy
            // return;
            if (!onCreate) {
                me.postMessage({
                    event: 'dropdown-size',
                    data: { containerId: this.options.containerId, onCreateSizing: false }
                });
            }
        }
        super.maximize();
    }

    hide() {
        const me = this;

        if (this.options.invitationMask) {
            me.postMessage({ event: 'dropdown-hidemask', data: {} });
        }
        // var currentState = fromState ? fromState : this.state.currentState.state;
        // this.state.changeState({ toState: WidgetStates.Hidden });
        super.hide();
    }
}
